import(/* webpackMode: "eager" */ "/app/src/app/projects/layout.js");
